import { IcBuilderArtifactScreen } from "@civala/investor-nexus-pitch"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/hub/ic-meetings/artifact")({
  component: IcBuilderArtifactScreen,
})
